import { attachmentBasePath } from '../../../logic/features/attachments/attachment.service';

export const createDownloadUrl = (id: number) => `${attachmentBasePath()}/${id}`;
